export default "__VITE_ASSET__495a99d5__"